import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from '@design-system/box';
import { Dotdotdot } from '@design-system/dotdotdot';
import { CATEGORIES, FontAwesomeIcon } from '@design-system/font-awesome-icon';
import { Image } from '@design-system/image';
import { Link } from '@design-system/link';
import { ScreenReadersContent } from '@design-system/screen-readers-content';
import { UsersAvatarList } from '@design-system/users-avatar-list';
import { useMemo } from 'react';
import { styled } from 'styled-components';
import { CONTENT_LIST_SIZES, } from '../types';
import { getGroupPresentationImageWrapperSizes } from '../utils';
export const GroupPresentation = ({ displayAvatars = false, displayLocation = true, displayMembers = true, image, isLast, location, members, membersLabel, name, onClick, path, seeMoreOnClick, size, totalMembers, }) => {
    const canReturnTotalMembers = displayMembers && !displayAvatars;
    const canDisplayLocation = displayLocation && location;
    const displaySeparationDot = canReturnTotalMembers && membersLabel && canDisplayLocation;
    const groupMembers = members
        ? members === null || members === void 0 ? void 0 : members.map((user, index) => {
            var _a;
            return ({
                id: (_a = user.id) !== null && _a !== void 0 ? _a : index,
                name: user.name,
                photo_thumb_url: user.photo_thumb_url,
            });
        })
        : [];
    const clickableProps = useMemo(() => onClick && {
        onClick,
    }, [onClick]);
    return (_jsxs(Box, { flexDirection: { _: 'column', m: 'row' }, mb: isLast ? 0 : { _: 5, m: 6 }, width: "100%", children: [_jsx(ImageWrapper, Object.assign({ "$isLast": isLast, "$size": size }, clickableProps, { children: _jsxs(Link, { styledOnlyOnHover: true, tabIndex: -1, to: path, width: "100%", children: [image ? (_jsx(Image, { alt: `Image for group ${name}`, height: "100%", src: image, style: { objectFit: 'cover' }, width: "100%" })) : (_jsx(IconWrapper, { children: _jsx(FontAwesomeIcon, { color: "primary", height: size === CONTENT_LIST_SIZES.SMALL ? '32px' : '35px', iconName: "user-group", iconType: CATEGORIES.DUOTONE }) })), _jsx(ScreenReadersContent, { children: name })] }) })), _jsxs(Box, { flexDirection: "column", justifyContent: "center", maxWidth: { _: '100%', m: '60%' }, children: [_jsx(Box, Object.assign({ mb: 1 }, clickableProps, { children: _jsx(Link, { font: "h4-semibold", styledOnlyOnHover: true, to: path, width: "100%", children: _jsx(Dotdotdot, { clamp: 2, children: name }) }) })), _jsx(Box, { children: size === CONTENT_LIST_SIZES.SMALL ? (_jsxs(Box, { flexDirection: "column", children: [canDisplayLocation && _jsx(Box, { mb: 1, children: location }), canReturnTotalMembers && (_jsx(Box, { font: "body-semibold-asphalt", children: membersLabel }))] })) : (_jsxs(_Fragment, { children: [canReturnTotalMembers && membersLabel, displaySeparationDot && ' · ', displayLocation && location] })) }), displayAvatars && members && (_jsx(Box, { mt: 1, children: _jsx(UsersAvatarList, { maxAvatars: 3, onClickMore: seeMoreOnClick, totalUsers: totalMembers, users: groupMembers }) }))] })] }));
};
const ImageWrapper = styled(Box).attrs(({ $size }) => {
    const sizes = getGroupPresentationImageWrapperSizes($size);
    return {
        height: '100%',
        maxWidth: sizes.maxWidth,
        minWidth: sizes.minWidth,
        mr: sizes.mr,
        mb: { _: 3, m: 0 },
    };
}) `
  aspect-ratio: 757/418;
  border-radius: ${({ theme }) => `${theme.themeVariables.globalBorderRadius}px`};
  overflow: hidden;
`;
const IconWrapper = styled(Box) `
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border: solid 1px ${({ theme }) => theme.colors.horizon};
  border-radius: ${({ theme }) => theme.themeVariables.globalBorderRadius}px;
  aspect-ratio: 186 / 102;
`;
//# sourceMappingURL=GroupPresentation.js.map